export default "__VITE_ASSET__CAKkmLdn__"